<template>

  <div v-if="group">

    <form class="form" v-on:submit.prevent="updateGroup">

    <h1>Group of <router-link :to="{ name: 'tour-edit', params: { id: group.tour_id }}">{{ group.tour.name }}</router-link></h1>

      <div class="box">

        <Errors/>
        <div class="p-2">
          <div class="row">
            <div class="col-md-3">
              <label for="start-date">Start date</label>
              <input id="start-date" type="date" v-model="group.start_date" required>
            </div>
            <div class="col-md-3">
              <label for="deposit-price">Deposit price (£)</label>
              <input id="deposit-price" type="number" v-model="group.deposit_price" :placeholder="'Set to ' + group.tour.deposit_price + ' in master'">
            </div>
            <div class="col-md-3">
              <label for="base-price">Base price (£)</label>
              <input id="base-price" type="number" v-model="group.base_price">
            </div>
            <div class="col-md-3">
              <label for="base-cost">Base cost (£)</label>
              <input id="base-cost" type="number" v-model="group.base_cost">
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-3">
              <label for="duration">Duration (days)</label>
              <input id="duration" type="number" v-model="group.duration" :placeholder="'Set to ' + group.tour.duration + ' in master'">
            </div>
            <div class="col-md-3">
              <label for="minimum-age">Minimum age</label>
              <input id="minimum-age" type="number" v-model="group.minimum_age" :placeholder="'Set to ' + group.tour.minimum_age + ' in master'">
            </div>
            <div class="col-md-3">
              <label for="release">Release days before</label>
              <input id="release" type="number" v-model="group.release_days_before" :placeholder="'Set to ' + group.tour.release_days_before + ' in master'">
            </div>
            <div class="col-md-3">
              <label for="places">Places available</label>
              <input id="places" type="number" v-model="group.available_places" :placeholder="'Set to ' + group.tour.tour_places + ' in master'">
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <label for="passengers">Places taken</label>
              <input id="passengers" type="number" v-model="group.passengers" readonly>
            </div>
            <div class="col-md-2">
              <label for="stop-sell">Stop sell</label>
              <label class="switch">
                <input id="stop-sell" type="checkbox" v-model="group.stop_sell">
                <span class="switch__slider"></span>
              </label>
            </div>
            <div class="col-md-4">
              <label for="is-special-instance">Is Special Group</label>
              <label class="switch">
                <input id="is-special-instance" type="checkbox" v-model="group.is_special_group">
                <span class="switch__slider"></span>
              </label>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">
              <div style=" flex-grow: 0; flex-shrink: 0; flex-basis: calc(60% - 1rem);">
                <label for="group_itinerary">Group itinerary details (in addition to master tour itinerary)</label>
                <textarea id="group_itinerary" style="max-width: 100%; min-height: 8rem" v-model="group.group_itinerary"></textarea>
              </div>
            </div>
            <div class="col-md-6">
              <div style=" flex-grow: 0; flex-shrink: 0; flex-basis: calc(40% - 1rem);">
                <label for="">Variables</label>
                <ul>
                  <li><strong>{{ '\{\{hotel\}\}' }}</strong>: Hotel name</li>
                  <li><strong>{{ '\{\{room_type\}\}' }}</strong>: Type of room</li>
                  <li><strong>{{ '\{\{board_basis\}\}' }}</strong>: Board basis of room</li>
                  <li><strong>{{ '\{\{hotel_contact\}\}' }}</strong>: Contact number of hotel</li>
                  <li><strong>{{ '\{\{hotel_address\}\}' }}</strong>: Address number of hotel</li>
                  <li><strong>{{ '\{\{hotel_resort\}\}' }}</strong>: Hotel resort</li>
                  <li><strong>{{ '\{\{transfer_pickup_time\}\}' }}</strong>: Transfer Pickup Time</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="form-wrap form-submit">
          <div class="mt-1" v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Updating...</span></button>
          </div>
          <div class="mt-1" v-else>
            <button type="submit" class="button" v-if="userRole == 1"><span>Update tour group</span></button>
          </div>
        </div>

      </div><!-- / box -->

    </form>

    <p><small>* If no data is entered then the system will use the equivalent data from the master tour.</small></p>

    <!-- Instances Start -->
    <!-- <div class="box mt-5">
      <div class="row">
        <div class="col-md-12 m-3">
          <h3> 
            Instances <ShowHideEye :showSection="showInstances" @toggle="showInstances = !showInstances"/>
            <button 
              class="button" 
              v-if="userRole == 1" 
              style="float: right; margin-right: 35px;"
              @click="checkFlightTimes()"
            >
              <span>Check Flight Times</span>
            </button>

            <button 
              class="button" 
              v-if="userRole == 1" 
              style="float: right; margin-right: 35px;"
              @click="manageTransfers()">
              <span>Manage Transfers</span>
            </button>
          </h3>
        </div>
      </div>
      <div class="row" v-if="showInstances">
        <div class="col-md-12">
          <form class="form" v-on:submit.prevent="addInstance">
            <fieldset>
              <div class="form-wrap">
                <div>
                  <label for="instance_title">Title</label>
                  <input id="instance_title" type="text" v-model="newInstance.instance_title">
                </div>
    
                <div>
                  <label for="departure-date">Departure date</label>
                  <input id="departure-date" type="date" v-model="newInstance.departure_date" required>
                </div>
    
                <div v-if="this.group.tour.tour_type == 'air'">
                  <label for="departure_airport">Departure Airport</label>
                  <v-select
                    index="id"
                    id="departure_airport"
                    label="airport_name"
                    :filterable="false"
                    :options="departure_airports"
                    v-model="newInstance.departure_airport_id"
                    v-debounce:500ms="searchDepartureAirports"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.iata_code }} - {{ option.airport_name }}
                    </template>
                  </v-select>
                </div>
    
                <div v-else-if="this.group.tour.tour_type == 'coach'">
                  <label for="region">Pickup point</label>
                  <v-select
                    v-model="newInstance.pickup_point_id"
                    label="pickup_point_name"
                    id="pickup_point"
                    :options="pickupPoints"
                    index="id"
                    required
                  />
                </div>
    
                <div>
                  <label for="is-special-instance">Is Special Instance</label>
                  <label class="switch">
                    <input id="is-special-instance" type="checkbox" v-model="newInstance.is_special_instance">
                    <span class="switch__slider"></span>
                  </label>
                </div>
    
                <div class="form-submit-inline">
                  <template v-if="this.getLoadStatus">
                    <button type="submit" class="button" disabled><span>Adding instance...</span></button>
                  </template>
                  <template v-else>
                    <button type="submit" class="button" v-if="userRole == 1"><span>Add instance</span></button>
                  </template>
                </div>
              </div>
            </fieldset>
          </form>
          
          <table class="table" cellspacing="0" cellpadding="0">
            <thead v-if="group.instances.length > 0">
              <tr>
                <th>
                  <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="" id="" value="checkedValue" class="custom-control-input">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"></span>
                  </label>
                </th>
                <th v-if="group.tour.tour_type == 'air'">Title</th>
                <th v-if="group.tour.tour_type == 'air'">Departure Airport</th>
                <th v-else-if="group.tour.tour_type == 'coach'">Pickup Region</th>
                <th>Start date</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="instance of group.instances" :key="instance.id" :class="{'is-special': instance.is_special_instance}">
                <td>
                  <label class="custom-control custom-checkbox">
                    <input type="checkbox" v-model="selectedInstancesForFlightTimeCheck" :value="instance.id" class="custom-control-input">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"></span>
                  </label>
                </td>
                <td>
                  {{ instance.instance_title }}
                </td>
                <td v-if="instance.airport && group.tour.tour_type == 'air'">{{ instance.airport.airport_name || '' }}</td>
                <td v-else-if="group.tour.tour_type == 'coach'"><span v-if="instance.pick_up_point">{{ instance.pick_up_point.pickup_point_name }}</span></td>
                <td>{{ instance.departure_date | formatDate}}</td>
                <td class="table-action"><a v-on:click="editInstance(instance.id)" class="icon icon--more">Edit</a></td>
                <td class="table-action">
                  <template v-if="userRole == 1">
                    <template v-if="instance.booking_count == 0">
                      <a v-on:click="deleteInstance(instance.id, instance.airport.airport_name)" class="icon icon--delete">Delete</a>
                    </template>
                    <template v-else>
                      <a href="javascript:void(0)" v-on:click="showNonDeletionMessage" class="icon icon--delete-disabled">Delete</a>
                    </template>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->
    <Instances 
      :departure_airports="departure_airports" 
      :group="group"
      @searchDepartureAirports="searchDepartureAirports"
      @manageTransfers="manageTransfers"
      @getGroup="getGroup"
    />
    <!-- / instances -->

    <!-- Accommodation Exclude -->
    <template>
      <div class="box mt-5">
        <div class="row">
          <div class="col-md-12 m-3">
            <h3> Accommodation Exclude <ShowHideEye :showSection="showAccomodationExclude" @toggle="showAccomodationExclude = !showAccomodationExclude"/> </h3>
          </div>
        </div>
        <div class="row" v-if="showAccomodationExclude">
          <div class="col-md-12">
            <table class="table" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <th>Accommodation name</th>
                  <th>Excluded</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="accommodation of group.tour.accommodation" :key="accommodation.id">
                  <td>{{ accommodation.details.accommodation_name }}</td>
                  <td>
                    <label class="switch" v-if="userRole == 1">
                      <input id="stop-sell" type="checkbox" :checked="isExcluded(accommodation)" @change="toggleAccommodationExclude($event, accommodation)">
                      <span class="switch__slider"></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <!-- / Accommodation Exclude -->


    <!-- Linked Groups -->
    <template v-if="groups">
      <div class="box mt-5">
        <div class="row">
          <div class="col-md-12 m-3">
            <h3> Linked Groups <ShowHideEye :showSection="showLinkedGroups" @toggle="showLinkedGroups = !showLinkedGroups"/> </h3>
          </div>
        </div>
        <div class="row" v-if="showLinkedGroups">
          <div class="col-md-12">
            <form class="form" v-on:submit.prevent="linkGroup">
              <fieldset>
                <div class="form-wrap">
    
                  <div>
                    <label>Group</label>
                    <v-select
                      v-model="newLink"
                      label="start_date"
                      id="newLink"
                      :options="groups"
                      index="id"
                      required
                    />
                  </div>
    
                  <div class="form-submit-inline">
                    <template v-if="this.getLoadStatus">
                      <button type="submit" class="button" disabled><span>Linking group...</span></button>
                    </template>
                    <template v-else>
                      <button type="submit" class="button" v-if="userRole == 1"><span>Link group</span></button>
                    </template>
                  </div>
    
                </div>
              </fieldset>
            </form>
            <table v-if="group.links" class="table" cellspacing="0" cellpadding="0">
              <thead v-if="group.links.length > 0">
                <tr>
                  <th>Start date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="link of group.links" :key="link.id">
                  <td><router-link :to="{ name: 'tour-group', params: { id: link.id }}">{{ link.start_date }}</router-link></td>
                  <td class="table-action">
                    <a v-on:click="unlinkGroup(link.id)" class="icon icon--delete" v-if="userRole == 1">Unlink</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <!-- / Linked Groups -->

    <!-- Documents -->
    <template v-if="group">
      <h2>Documents</h2>
      <TourGroupDocuments :group="group"></TourGroupDocuments>
    </template>
    <!-- / Documents -->
    
    <!-- Tour Group Internal Payments -->
    <template v-if="group">
      <TourGroupInternalPayments 
        :suppliers="suppliers" 
        :servicesTypes="services_types"
        :tourManagers="tour_managers"
        :tourInternalPayments="group.internal_payments" 
        :grossRevenue="grossRevenue" 
        :cancellationRevenue="group.cancellation_revenue" 
        @handle-new-payment="updateInterPayments"
        @updateRevenue="updateRevenue"/>
    </template>
    
    <!-- /Tour Group Internal Payments -->

    <!-- Bookings -->
    <template v-if="group.bookings && group.bookings.length > 0">
      <div class="box mt-5">
        <div class="row">
          <div class="col-md-12">
            <div class="row m-3">
              <div class="col-md-4">
                <h3> 
                  Bookings for this tour group
                  <ShowHideEye :showSection="showGroupBookins" iconWidth="10%" @toggle="showGroupBookins = !showGroupBookins"/>
                </h3>
              </div>
              <div class="col-md-6" v-if="userRole == 1">
                <button 
                  class="button" 
                  style="float:right" 
                  type="button" 
                  v-on:click="emailTravelDocs"
                >
                    Email travel docs to customer
                </button>
                <button class="button mx-2" style="float:right" v-on:click="groupedAccommodation" type="button" :disabled="selectedBookings.length < 1">Update Bulk Accommodation</button>
              </div>
              <div class="col-md-2">
                <TriggerSMS :bookings="selectedBookingIDS" :isDisabled="selectedBookingIDS.length < 1" />
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="showGroupBookins">
          <div class="col-md-12">
            <table class="table" cellspacing="0" cellpadding="0" v-if="group.bookings">
              <thead v-if="group.bookings.length > 0">
                <tr>
                  <th>
                    <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" />
                  </th>
                  <th>Booking ref</th>
                  <th>Airline Ref No</th>
                  <th>Accommodation</th>
                  <th>Customer</th>
                  <th>Date booked</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="booking of group.bookings" :key="booking.id" :class="[!!booking.booking[0].cancelled_at ? 'booking--cancelled' : false]">
                  <td>
                    <input type="checkbox" v-model="selectedBookings" :value="booking.id">
                  </td>
                  <td><router-link :to="{ name: 'booking-edit', params: { id: booking.booking[0].id }}" :class="(booking.booking[0].changes_accepted == 0 ) ? 'color-orange' : ''">{{ booking.booking[0].booking_ref || booking.booking[0].old_booking_id }}</router-link></td>
                  <td>{{ booking.airline_ref ? booking.airline_ref : '-' }}</td>
                  <td v-if="booking.room">
                    {{ booking.room.accommodation.details.accommodation_name }} 
                    <small>{{ booking.room.name }} - {{ booking.room.board_basis }}</small>
                    <template v-if="booking.selected_multiple_room"> <strong> ({{ booking.selected_multiple_room }}) </strong> </template>
                  </td>
                  <td v-else>-</td>
                  <td v-if="booking.booking[0].customer"><router-link :to="{ name: 'customer-edit', params: { id: booking.booking[0].customer.id }}">{{ booking.booking[0].customer.first_name }} {{ booking.booking[0].customer.last_name }}</router-link></td>
                  <td v-else>No customer attached to booking</td>
                  <td>{{ booking.booking[0].created_at | formatDateTime }}</td>
                  <td class="table-action"><a v-on:click="viewBooking(booking.booking[0].id)" class="icon icon--more">View</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <!-- / Bookings -->

    <div class="modal" v-if="bulkAccommodationUpdateModal">
     <h1>Tour Group Bulk Update Accommodation</h1>
      <div class="box">
        <TourGroupAccommodationUpdate :grouped-bookings="groupedBookings"/>
      </div>
      <button type="button" class="icon icon--unlink" v-on:click="bulkAccommodationUpdateModal = false">Close</button>
    </div>

    <TourGroupInstanceTransfer 
      :showTransferInstanceModal="showTransferInstanceModal"
      :tourGroupInstances="selectedInstancesDetails"
      :GroupInstancesTransfers="groupInstancesTransfersDetails"
      :accomodations="groupInstancesAccmodations"
      :departure_date="group.start_date"
      @closeModal="showTransferInstanceModal = false"
      />
  </div><!-- / group -->

</template>

<style scoped>
.booking--cancelled {
  text-decoration: line-through;
}
</style>

<script>
import Errors from '@/components/Errors.vue'
import TourGroupDocuments from '@/components/TourGroupDocuments.vue'
import TourGroupInternalPayments from '@/components/TourGroupInternalPayments.vue'
import TourGroupAccommodationUpdate from '@/components/TourGroupAccommodationUpdate.vue'
import TourGroupInstanceTransfer from '@/components/Tour/TourGroupInstanceTransfer.vue'
import Instances from '@/components/Tour/Group/Instances.vue'
import ShowHideEye from '@/components/ShowHideEye.vue'
import TriggerSMS from "@/components/TriggerSMS.vue";

import {mapGetters} from 'vuex'

export default {
  name: 'GroupEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
        this.showInstances = true
        this.showAccomodationExclude = true
        this.showLinkedGroups = true
        this.showGroupBookins = true
      }
      return user_role
    }
  },
  data () {
    return {
      loading: false,
      group: null,
      groups: null,
      errors: null,
      departure_airports: [],
      newInstance: {
        currency: 'GBP',
        indirect_flights: 0
      },
      newAccommodation: {
        tour_group_id: this.$route.params.id,
      },
      newLink: null,
      accommodation: [],
      pickupPoints: [],
      tour_accommodation: [],
      groupedBookings: {},
      bulkAccommodationUpdateModal: false,
      selectedBookings: [],
      selectedBookingIDS: [],
      selectAll: false,
      suppliers:[],
      services_types:[],
      tour_managers:[],
      grossRevenue: 0,
      cancellationRevenue: 0,
      showInstances: false,
      showAccomodationExclude: false,
      showLinkedGroups: false,
      showGroupBookins: false,
      showTransferInstanceModal: false,
      selectedInstancesDetails:[],
      groupInstancesTransfersDetails:[],
      groupInstancesAccmodations: [],
      selectedInstancesForFlightTimeCheck: [],
      defaultAdminEmail: null
    }
  },
  components: {
    Errors,
    TourGroupDocuments,
    TourGroupAccommodationUpdate,
    TourGroupInternalPayments,
    ShowHideEye,
    TourGroupInstanceTransfer,
    Instances,
    TriggerSMS
  },
  created () {
    this.getGroup()
    this.getAccommodation()
  },
  watch: {
    '$route': 'getGroup',
    // When selectedValues array changes, update the selectAll checkbox
    selectedBookings(newValues) {
      this.selectAll = newValues.length === this.group.bookings.length;
      let selectedHolidayBookingIds = []
      if (newValues.length > 0) {
        this.group.bookings.forEach(booking => {
          if (newValues.includes(booking.id)) {
            selectedHolidayBookingIds.push(booking.holiday_booking_id)
          }
        });
      }
      this.selectedBookingIDS = selectedHolidayBookingIds
    },
  },
  methods: {
    getGroup () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.group = response.data.tourGroup
        this.suppliers = response.data.suppliers
        this.services_types = response.data.servicesTypes
        this.tour_managers = response.data.tour_managers
        this.grossRevenue = this.group.gross_revenue
        this.cancellationRevenue = this.group.cancellation_revenue
        this.newInstance.tour_id = this.group.tour_id;
        this.newInstance.tour_group_id = this.group.id;
        this.newInstance.departure_date = JSON.parse(JSON.stringify(this.group.start_date));
        this.tour_accommodation = this.group.tour ? this.group.tour.accommodation : [];
        this.defaultAdminEmail = response.data.variables.admin_email
        this.getLinkableGroups()
      })
    },
    updateGroup () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.group),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    getAccommodation () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.accommodations = response.data
        this.$store.dispatch('setLoadStatus')
      })
    },
    addInstance () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/instances', {
        method: 'POST',
        body: JSON.stringify(this.newInstance),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.newInstance.departure_airport = null
          this.getGroup()
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    editInstance (instanceID) {
      this.$router.push({ name: 'tour-instance', params: { id: instanceID }})
    },
    deleteInstance (instanceID ,name) {
      this.$dialog
      .confirm(`Are you sure you want to delete instance "${name}" ?`)
      .then(() => {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'tours/instances/' + instanceID + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.success == true) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.getGroup()
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      }).catch(() => {
        console.log('Clicked on cancel');
      });
    },
    searchDepartureAirports (search) {
      if(this.$data.loading === false ) {
        this.$data.loading = true
        fetch(this.$api + 'airports/search/' + search, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$data.departure_airports = response.data
          this.$data.loading = false
        })
      }
    },
    getRegions () {
      this.$store.dispatch('setLoadStatus')
      fetch( this.$api + 'pickup/regions/', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.regions = response.data
        this.$store.dispatch('setLoadStatus')
      })
    },
    getLinkableGroups () {
      this.$store.dispatch('setLoadStatus')
      fetch( this.$api + 'tours/' + this.group.tour_id + '/groups', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.groups = response.data.filter(
          group => group.start_date !== this.group.start_date
          // || this.group.links.some(link => link.start_date == group.start_date)
          // this.group.links.includes(group.start_date)
        );
        this.$store.dispatch('setLoadStatus')
      })
    },
    linkGroup () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups/' + this.$route.params.id + '/link', {
        method: 'POST',
        body: JSON.stringify({
          id: this.newLink
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getGroup()
        } else {
          this.$notify({
            type: 'error',
            title: response.error
          });
        }
        this.$store.dispatch('setLoadStatus')
      })
    },
    unlinkGroup (link) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups/' + this.$route.params.id + '/unlink', {
        method: 'POST',
        body: JSON.stringify(link),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getGroup()
        } else {
          this.$notify({
            type: 'error',
            title: response.error
          });
        }
        this.$store.dispatch('setLoadStatus')
      })
    },
    addAccommodation () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups/' + this.$route.params.id + '/accommodation', {
        method: 'POST',
        body: JSON.stringify(this.newAccommodation),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getGroup()
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    editAccommodation(accommodationId) {
      this.$router.push({ name: 'tour-accommodation', params: { id: accommodationId }})
    },
    deleteAccommodation (accommodationId) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/accommodation/' + accommodationId + '/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getGroup()
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    viewBooking(data) {
      this.$router.push({ name: 'booking-edit', params: { id: data }})
    },
    emailTravelDocs() {
      this.$swal.fire({
        title: "Are you sure you want to send email to customer ?",
        text: "If in doubt, please click test button to send a test email to yourself.",
        icon: "warning",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Continue',
        denyButtonText: 'Cancel',
        cancelButtonText: 'Send Test Email'
      }).then((result) => {
        if (result.isConfirmed) {
          this.triggerTravelDocEmail()
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          // Show email input modal for test email
          this.$swal.fire({
            title: 'Send Test Email',
            text: 'Enter the email address where you want to send the test email:',
            input: 'email',
            inputValue: this.defaultAdminEmail || '',
            inputPlaceholder: 'Enter email address',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Send Test Email',
            cancelButtonText: 'Cancel',
            inputValidator: (value) => {
              if (!value) {
                return 'You need to enter an email address!'
              }
              // Basic email validation
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(value)) {
                return 'Please enter a valid email address!'
              }
            }
          }).then((emailResult) => {
            if (emailResult.isConfirmed) {
              this.triggerTravelDocEmail(true, emailResult.value)
            }
          });
        }
      });
    },
    isExcluded(accommodation) {
      const excluded = this.group.excluded_accommodations.filter(
        excluded_accommodation =>
          excluded_accommodation.accommodation_id ===
            accommodation.accommodation_id &&
          excluded_accommodation.tour_accommodation_id === accommodation.id
      );

      return excluded.length > 0 ? true : false;
    },
    toggleAccommodationExclude(event, accommodation) {
      this.$dialog
      .confirm('Are you sure you want to exclude the accommodation?')
      .then(() => {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'tours/groups/exclude-accommodation', {
          method: 'POST',
          body: JSON.stringify({
            tour_group_id: this.$route.params.id,
            tour_accommodation_id: accommodation.id,
            accommodation_id: accommodation.accommodation_id,
            checked: event.target.checked,
          }),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success == true) {
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else {
            // Reset the checkbox toggle state on error
            event.target.checked = !event.target.checked;
            this.$notify({
              type: 'error',
              title: response.error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      })
      .catch(() => {
        // Reset the checkbox toggle state on error
        event.target.checked = !event.target.checked;
        console.log('Clicked on cancel');
      });
    },
    groupedAccommodation() {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups/' + this.$route.params.id + '/booking/group-accommodation', {
        method: 'POST',
        body: JSON.stringify({
          selected_bookings: this.selectedBookings
        }),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.groupedBookings = response.data;
          if(this.groupedBookings) {
            this.bulkAccommodationUpdateModal = true
          }
        } else {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      })
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedBookings = this.group.bookings.map(item => item.id);
      } else {
        this.selectedBookings = [];
      }
    },
    showNonDeletionMessage() {
      this.$swal({
        icon: "error",
        title: "Oops...",
        text: "Sorry, this instance have active bookings.",
      });
    },
    updateInterPayments(paymentObject){
      this.group.internal_payments = paymentObject
    },
    updateRevenue(revenue) {
      this.grossRevenue = revenue.gross_revenue
      this.cancellationRevenue = revenue.cancellation_revenue
    },
    manageTransfers() {
      this.$store.dispatch('setLoadStatus')
      fetch(`${this.$api}tours/groups/${this.$route.params.id}/fetch-instances-data`, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')

        this.selectedInstancesDetails = response.data.instance
        this.groupInstancesTransfersDetails = response.data.group_instance_transfers

        this.groupInstancesAccmodations = response.data.accomodations
        this.showTransferInstanceModal = true
      })
    },
    triggerTravelDocEmail(isTest = false, testEmail = null) {
      this.$store.dispatch('setLoadStatus')
      const requestBody = { is_test: isTest };
      if (isTest && testEmail) {
        requestBody.test_email = testEmail;
      }
      
      fetch(this.$api + 'tours/groups/' + this.$route.params.id + '/documents/email-travel-document?type=email_customer', {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      })
      .catch(() => {
        console.log('Clicked on cancel');
      });
    },
  }
}
</script>
<style scoped>
.is-special {
  background: #e8e8e8;
}
button:disabled,button[disabled]{
  cursor: not-allowed;
  background-color: #f0624d8a;
}
</style>
